(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FlowboxProductPage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var FEED_URL = 'https://gateway.getflowbox.com/v1/public/feed/';
    var LOCALES = { es: 'es-es', it: 'it-it', de: 'de-de', fr: 'fr-fr' };
    var POSTS_PER_PAGE = 29; // what flowbox.js asks for; the product's own posts come first
    var GIVE_UP_MS = 10000;
    var CDN = 'https://cdn.flbx.io/';
    var TILE_WIDTHS = [320, 480, 640];
    var TILE_SIZES = '(max-width: 767px) 38vw, 20vw';
    var VIEWER_WIDTH = 1600; // px requested from the Flowbox CDN for the viewer
    var VIEWER_THUMB_WIDTH = 240;

    /**
     * Flowbox's resizing CDN: https://cdn.flbx.io/image/<base64 JSON> whose JSON
     * names the media (its feed url minus the CDN host) and the edits to apply.
     */
    function cdnImage(mediaKey, width) {
      var payload = { key: mediaKey, edits: { toFormat: 'webp', resize: { width: width } } };
      return CDN + 'image/' + btoa(JSON.stringify(payload)).replace(/\+/g, '-').replace(/\//g, '_');
    }

    /**
     * Product keys look like "<shop>_<SKU>_<catalog>". Keeps posts tagged with
     * this product alone: fallback posts carry other products' SKUs, and a post
     * tagged with several products has no way to say which photo shows which.
     */
    function isOnlyTaggedWith(post, sku) {
      var keys = post.productKeys || [];
      return keys.length === 1 && keys[0].split('_').slice(1, -1).join('_') === sku;
    }

    /** Each own post's first image, in feed order, as { mediaKey, alt }. */
    function ownPhotos(feed, sku) {
      var out = [];
      (feed.posts || []).forEach(function (post) {
        if (!isOnlyTaggedWith(post, sku)) return;
        var image = (post.media || []).filter(function (m) {
          return m.type === 'image' && m.url && m.url.indexOf(CDN) === 0;
        })[0];
        if (!image) return;
        var alt = post.altText && post.altText[0];
        out.push({ mediaKey: image.url.slice(CDN.length), alt: (alt && alt.en) || '' });
      });
      return out;
    }

    function buildTile(photo, index) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'product-flow__tile';
      tile.setAttribute('data-index', index);

      var img = document.createElement('img');
      img.src = cdnImage(photo.mediaKey, 480);
      img.srcset = TILE_WIDTHS.map(function (w) {
        return cdnImage(photo.mediaKey, w) + ' ' + w + 'w';
      }).join(', ');
      img.sizes = TILE_SIZES;
      img.alt = photo.alt;
      img.loading = 'lazy';
      img.decoding = 'async';

      tile.appendChild(img);
      return tile;
    }

    /** The theme's product-photo viewer, opened on the clicked photo. */
    function openViewer(photos, index) {
      if (!window.theme || typeof theme.buildGalleryViewer !== 'function') return;

      var images = photos.map(function (photo) {
        var thumb = document.createElement('img');
        thumb.className = 'product-flow__viewer-thumb';
        thumb.src = cdnImage(photo.mediaKey, VIEWER_THUMB_WIDTH);
        thumb.alt = '';
        return { thumbTag: thumb, zoomUrl: cdnImage(photo.mediaKey, VIEWER_WIDTH) };
      });

      theme.buildGalleryViewer({
        images: images,
        currentImage: images[index].zoomUrl,
        prev: theme.icons.chevronLeft,
        next: theme.icons.chevronRight,
        close: theme.icons.close
      });
    }

    function load(root) {
      var track = root.querySelector('[data-product-flow-track]');
      var sku = root.dataset.productId;
      var photos = [];

      var hide = function () {
        (root.closest('.shopify-section') || root).style.display = 'none';
      };

      track.addEventListener('click', function (event) {
        var tile = event.target.closest('.product-flow__tile[data-index]');
        if (tile) openViewer(photos, Number(tile.getAttribute('data-index')));
      });

      root.querySelectorAll('[data-product-flow-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = Number(button.getAttribute('data-product-flow-step'));
          track.scrollBy({ left: step * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });

      var url =
        FEED_URL + encodeURIComponent(root.dataset.flowKey) +
        '?postsPerPage=' + POSTS_PER_PAGE +
        '&productId=' + encodeURIComponent(sku) +
        '&locale=' + (LOCALES[root.dataset.locale] || 'en-eu');
      var controller = 'AbortController' in window ? new AbortController() : null;
      var timer = setTimeout(function () {
        if (controller) controller.abort();
      }, GIVE_UP_MS);

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error('Flowbox feed ' + response.status);
          return response.json();
        })
        .then(function (feed) {
          photos = ownPhotos(feed, sku);
          if (!photos.length) return hide();

          var fragment = document.createDocumentFragment();
          photos.forEach(function (photo, index) {
            fragment.appendChild(buildTile(photo, index));
          });
          track.replaceChildren(fragment);
          root.classList.toggle('product-flow--scrolls', track.scrollWidth > track.clientWidth + 1);
        })
        .catch(hide) // blocked, slow or down: no section
        .then(function () {
          clearTimeout(timer);
        });
    }

    /** Fetches only once the section comes within reach of the viewport. */
    function init(root) {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';

      if (!('IntersectionObserver' in window)) return load(root);
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load(root);
        },
        { rootMargin: '600px 0px' }
      );
      observer.observe(root);
    }

    function initAll(scope) {
      scope.querySelectorAll('[data-product-flow]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["autoscroll-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAutoscrollGallery(section) {
      var viewport = section.querySelector('[data-autoscroll-viewport]');
      var track = section.querySelector('[data-autoscroll-track]');
      if (!viewport || !track) return;

      var autoplayAttr = (section.getAttribute('data-autoplay') || '').toLowerCase();
      var autoplay = autoplayAttr !== 'false' && autoplayAttr !== '';
      var delay = parseInt(section.getAttribute('data-autoplay-ms'), 10) || 4000;
      var prevBtn = section.querySelector('[data-autoscroll-prev]');
      var nextBtn = section.querySelector('[data-autoscroll-next]');
      var timer = null;
      var paused = false;
      var currentIndex = 0;
      var programmaticScroll = false;
      var programmaticScrollClearTimer = null;
      var originalCount = track.children.length;
      var loopEnabled = false;

      function markProgrammaticScroll() {
        programmaticScroll = true;
        if (programmaticScrollClearTimer) window.clearTimeout(programmaticScrollClearTimer);
        // Smooth scroll takes time — give it ~700ms before treating new scroll events as user-driven
        programmaticScrollClearTimer = window.setTimeout(function () {
          programmaticScroll = false;
        }, 700);
      }

      function getStep() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      // Infinite loop setup: clone enough leading slides at the end so the
      // viewer never sees a gap when the carousel scrolls past the last slide.
      // Clone 2 to cover desktop (which still shows 2 items per viewport).
      function setupLoop() {
        if (originalCount <= 1) return;
        var cloneCount = Math.min(originalCount, 2);
        for (var i = 0; i < cloneCount; i++) {
          var clone = track.children[i].cloneNode(true);
          clone.setAttribute('data-clone', '1');
          // strip ids from clones to avoid duplicate ids
          clone.removeAttribute('id');
          var nestedIds = clone.querySelectorAll('[id]');
          for (var j = 0; j < nestedIds.length; j++) nestedIds[j].removeAttribute('id');
          track.appendChild(clone);
        }
        loopEnabled = true;
      }

      // Call setup once on init
      setupLoop();

      // The "real" max scroll for looping = scrollLeft of the first clone item
      function realMaxScroll() {
        if (!loopEnabled) return maxScroll();
        var step = getStep();
        return originalCount * step; // first clone starts here
      }

      // Snap-to-real after a smooth scroll into clone zone or before zero.
      // Called once the smooth animation should have finished.
      function snapBackIfNeeded() {
        if (!loopEnabled) return;
        var step = getStep();
        if (step <= 0) return;
        var realLen = originalCount * step;
        if (track.scrollLeft >= realLen - 1) {
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = track.scrollLeft - realLen;
          window.requestAnimationFrame(function () {
            track.style.scrollBehavior = '';
          });
        }
      }

      function next() {
        var step = getStep();
        if (step <= 0) return;
        var anchorIndex = Math.round(track.scrollLeft / step);
        var target = (anchorIndex + 1) * step;

        markProgrammaticScroll();
        track.scrollTo({ left: target, behavior: 'smooth' });
        currentIndex = Math.round(target / step);

        if (loopEnabled) {
          window.setTimeout(snapBackIfNeeded, 650);
        }
      }

      function prev() {
        var step = getStep();
        if (step <= 0) return;
        var current = track.scrollLeft;

        if (loopEnabled && current <= 1) {
          var realLen = originalCount * step;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = realLen;
          window.requestAnimationFrame(function () {
            track.style.scrollBehavior = '';
            markProgrammaticScroll();
            track.scrollTo({ left: realLen - step, behavior: 'smooth' });
            currentIndex = originalCount - 1;
          });
          return;
        }

        var anchorIndex = Math.round(current / step);
        var target = (anchorIndex - 1) * step;
        if (target < 0) target = 0;
        markProgrammaticScroll();
        track.scrollTo({ left: target, behavior: 'smooth' });
        currentIndex = Math.round(target / step);
      }

      function start() {
        if (!autoplay) return;
        if (timer) return;
        if (originalCount <= 1) return;
        timer = window.setInterval(function () {
          if (!paused && document.visibilityState !== 'hidden') {
            next();
          }
        }, delay);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          prev();
          stop();
          start();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          next();
          stop();
          start();
        });
      }

      function restart() {
        stop();
        start();
      }

      // Pause only during actual scrolling/dragging — hover/focus do NOT pause.
      // Touch: pause while finger is down, restart timer when released
      track.addEventListener('touchstart', function () {
        paused = true;
        stop();
      }, { passive: true });
      track.addEventListener('touchend', function () {
        paused = false;
        restart();
      }, { passive: true });
      track.addEventListener('touchcancel', function () {
        paused = false;
        restart();
      }, { passive: true });

      // Desktop pointer drag (mouse only — let touch use native scroll)
      var DRAG_THRESHOLD = 6;
      var isDown = false;
      var dragStarted = false;
      var startX = 0;
      var startScroll = 0;
      var downTarget = null;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (e.button !== 0) return;
        isDown = true;
        dragStarted = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        downTarget = e.target;
        paused = true;
        stop();
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (!dragStarted) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          dragStarted = true;
          track.classList.add('is-dragging');
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        }
        track.scrollLeft = startScroll - dx;
        e.preventDefault();
      });

      var justDragged = false;
      function endDrag(e) {
        if (!isDown) return;
        var wasDragging = dragStarted;
        isDown = false;
        dragStarted = false;
        if (wasDragging) {
          track.classList.remove('is-dragging');
          try { track.releasePointerCapture(e.pointerId); } catch (err) {}
          justDragged = true;
          window.setTimeout(function () { justDragged = false; }, 50);
        }
        paused = false;
        restart();
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      // Swallow the click that immediately follows a drag, but let plain clicks through
      track.addEventListener('click', function (e) {
        if (justDragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      var scrollSyncTimer = null;
      var userScrollEndTimer = null;
      track.addEventListener('scroll', function () {
        // User-initiated scroll → pause autoplay, then restart timer once scroll settles
        if (!programmaticScroll && !isDown) {
          paused = true;
          stop();
          if (userScrollEndTimer) window.clearTimeout(userScrollEndTimer);
          userScrollEndTimer = window.setTimeout(function () {
            // After user-driven scroll ends, snap back if they wandered into clone zone
            snapBackIfNeeded();
            paused = false;
            restart();
          }, 200);
        }

        if (scrollSyncTimer) window.clearTimeout(scrollSyncTimer);
        scrollSyncTimer = window.setTimeout(function () {
          var step = getStep();
          if (step > 0) {
            currentIndex = Math.round(track.scrollLeft / step);
          }
        }, 120);
      }, { passive: true });

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          stop();
        } else {
          start();
        }
      });

      // Defer start until layout is settled (production: images/lazyload may shift)
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          window.setTimeout(start, 100);
        });
      } else {
        window.setTimeout(start, 200);
      }

      // Restart on resize (per-view changes break the index)
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          stop();
          currentIndex = 0;
          track.scrollTo({ left: 0, behavior: 'auto' });
          start();
        }, 250);
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:unload', function (evt) {
          if (evt.target === section) stop();
        });
      }
    }

    function initAll() {
      var sections = document.querySelectorAll('[data-section-type="autoscroll-gallery"]');
      sections.forEach(function (section) {
        if (section.dataset.autoscrollInited === 'true') return;
        section.dataset.autoscrollInited = 'true';
        initAutoscrollGallery(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (evt) {
      var section = evt.target.querySelector('[data-section-type="autoscroll-gallery"]');
      if (section && section.dataset.autoscrollInited !== 'true') {
        section.dataset.autoscrollInited = 'true';
        initAutoscrollGallery(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /*
   * Cart line removal that survives stale line keys.
   *
   * Each remove (x) link is a plain GET to /cart/change?id=<line key>&quantity=0
   * with the key baked in at render time. Line keys are not stable: whenever
   * the automatic 2x1 discount reallocates (another line added, removed or its
   * quantity changed) Shopify re-keys the affected lines, including ones the
   * shopper never touched. A link clicked before the page has re-rendered —
   * right after a quantity change, a double tap, or a page restored from the
   * back/forward cache — then points at a key that no longer exists, and
   * Shopify answers with its bare 422 "Cannot find variant" error page.
   *
   * So the click reads the live cart first, finds the line by its current key
   * (falling back to the same variant), removes it over AJAX and lets the
   * theme re-render the list. Anything unexpected reloads the cart page
   * instead of navigating to the error. Without JS the link still works.
   */
  (function () {
    'use strict';

    var BUSY_CLASS = 'is-removing';

    function routes() {
      var r = (window.theme && window.theme.routes) || {};
      return {
        cart: r.cart_url || '/cart',
        change: r.cart_change_url || '/cart/change'
      };
    }

    function findLine(cart, staleKey) {
      var variantId = String(staleKey).split(':')[0];
      var exact = null;
      var sameVariant = null;
      cart.items.forEach(function (item) {
        if (item.key === staleKey) exact = item;
        if (!sameVariant && String(item.variant_id) === variantId) sameVariant = item;
      });
      return exact || sameVariant;
    }

    function removeLine(link, staleKey) {
      var r = routes();
      link.classList.add(BUSY_CLASS);
      link.setAttribute('aria-disabled', 'true');

      fetch(r.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (res) {
          if (!res.ok) throw new Error('cart ' + res.status);
          return res.json();
        })
        .then(function (cart) {
          var line = findLine(cart, staleKey);
          // Already gone (removed in another tab, or by the first of two taps).
          if (!line) return null;
          return fetch(r.change + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (res) {
            if (!res.ok) throw new Error('change ' + res.status);
            return res.json();
          });
        })
        .then(function (cart) {
          // An emptied cart renders a different layout: reload for it, and
          // for the already-gone case, so the page matches the real cart.
          if (!cart || cart.item_count === 0) {
            window.location.reload();
            return;
          }
          // The cart section re-renders its list and totals on this event;
          // the header count listens to it too.
          document.documentElement.dispatchEvent(
            new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
          );
        })
        .catch(function () {
          window.location.reload();
        });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('#cartform a.remove');
      if (!link) return;
      var item = link.closest('[data-cart-item-key]');
      if (!item || !window.fetch) return;

      event.preventDefault();
      if (link.classList.contains(BUSY_CLASS)) return;
      removeLine(link, item.getAttribute('data-cart-item-key'));
    });

    // A cart page restored from the back/forward cache (e.g. Back from
    // checkout) carries the keys it was rendered with; fetch a fresh one.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) window.location.reload();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
